import type { DefaultTheme } from "styled-components";
import {
  BranchSemanticColour,
  branchColour,
} from "@ifgengineering/design-tokens/legacy";

/** The only colour read on surfaces held to the Figma branch palette: a colour by its Figma name. */
export const branch = (
  theme: DefaultTheme,
  name: BranchSemanticColour
): string => branchColour(theme.colors, name);
